import React from 'react';
import { useMsal } from '@azure/msal-react';

import { ExitIcon } from '../CustomIcon/ExitIcon';

import styles from './FooterMenu.module.css';

export default function FooterMenu() {
    const { instance } = useMsal();

    const handleLogout = async (instance) => {
        await instance.logoutRedirect().catch(e => {
            console.error(e);
        });
    }

    return (
        <div className={styles.footer}>
            <div className={styles.infoContainer}>
                <p className={styles.info}>© ПАО «Северсталь» 2022</p>
            </div>
            <div className={styles.exitButton}>
                <button className={styles.button} onClick={() => handleLogout(instance)}>
                    <div className={styles.buttonContent}>
                        <ExitIcon />
                        <span>Выход</span>
                    </div>
                </button>
            </div>
        </div>
    );
}
